/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MarketRSSWatchSettingFeedData = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The MarketRSSWatchSettingFeedData model module.
   * @module model/MarketRSSWatchSettingFeedData
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MarketRSSWatchSettingFeedData</code>.
   * @alias module:model/MarketRSSWatchSettingFeedData
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>MarketRSSWatchSettingFeedData</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MarketRSSWatchSettingFeedData} obj Optional instance to populate.
   * @return {module:model/MarketRSSWatchSettingFeedData} The populated <code>MarketRSSWatchSettingFeedData</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SettingID')) {
        obj['SettingID'] = ApiClient.convertToType(data['SettingID'], 'Integer');
      }
      if (data.hasOwnProperty('AddedTimeStamp')) {
        obj['AddedTimeStamp'] = ApiClient.convertToType(data['AddedTimeStamp'], 'Date');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('DrillToURI')) {
        obj['DrillToURI'] = ApiClient.convertToType(data['DrillToURI'], 'String');
      }
      if (data.hasOwnProperty('ContentText')) {
        obj['ContentText'] = ApiClient.convertToType(data['ContentText'], 'String');
      }
      if (data.hasOwnProperty('ContentHtml')) {
        obj['ContentHtml'] = ApiClient.convertToType(data['ContentHtml'], 'String');
      }
      if (data.hasOwnProperty('ContentImageURI')) {
        obj['ContentImageURI'] = ApiClient.convertToType(data['ContentImageURI'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} SettingID
   * @default 0
   */
  exports.prototype['SettingID'] = 0;
  /**
   * @member {Date} AddedTimeStamp
   */
  exports.prototype['AddedTimeStamp'] = undefined;
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {String} DrillToURI
   * @default ''
   */
  exports.prototype['DrillToURI'] = '';
  /**
   * @member {String} ContentText
   * @default ''
   */
  exports.prototype['ContentText'] = '';
  /**
   * @member {String} ContentHtml
   * @default ''
   */
  exports.prototype['ContentHtml'] = '';
  /**
   * @member {String} ContentImageURI
   * @default ''
   */
  exports.prototype['ContentImageURI'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


